import { OrderedMap } from "immutable";
import { COMPANY_TYPES } from "./enums";
import generateLink from "../components/generate-link";
import { formatCurrency } from "../../../utils";
import { TABLE_DATA_TYPES } from "constants/table-data-types";
const getDocumentStatusLabel = _ => {
    /*eslint-disable*/
    switch (_) {
        case true:
            return "Approved";
        case false:
            return "Rejected";
        case null:
        default:
            return "Pending Review";
    }
    /*eslint-enable*/
};

export const ATTACHMENT_TABLE_COLUMNS = new OrderedMap({
    file_name: {
        key: "file_name",
        title: "Name",
        dataIndex: "file_name"
    },
    document: {
        key: "document",
        title: "Type",
        dataIndex: "document.document_name",
        // render:_ => _ && _.document_name
    },
    create_date: {
        key: "create_date",
        title: "Created",
        dataIndex: "create_date",
        render: _ => _ && _.format("DD MMM YY")
    },
    status: {
        key: "status",
        title: "Status",
        dataIndex: "status",
        render: _ => getDocumentStatusLabel(_)
    },
    remarks: {
        key: "remarks",
        title: "Remarks",
        dataIndex: "remarks",
        width: 200
    },
    is_uploaded_from_retail_app: {
        key: "is_uploaded_from_retail_app",
        title: "Uploaded by Customer",
        dataIndex: "is_uploaded_from_retail_app",
        render: _ => _ ? "Yes" : "No"
    }
});

export const COMPANY_LOS_DISTRIBUTOR_PROFILE_COLS = new OrderedMap({
    name: {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width: 200,
        dataType: TABLE_DATA_TYPES.STRING,
        render: (_, record) => generateLink(`/app/companies/${record.id}`, record.name)
        // sorter: (a, b) => stringComparator(a.name, b.name),
    },
    anchor: {
        title: "Anchor",
        dataIndex: "anchor",
        key: "anchor",
        width: 200,
        dataType: TABLE_DATA_TYPES.STRING,
    },
    primary_rm: {
        title: "Primary RM",
        dataIndex: "primary_rm",
        key: "primary_rm",
        width: 200,
        dataType: TABLE_DATA_TYPES.STRING,
    },
    primary_brands: {
        title: "Primary Brand",
        key: "primary_brands",
        dataIndex: "primary_brands",
        width: 200,
        dataType: TABLE_DATA_TYPES.STRING,
    },
    gst_state: {
        title: "State",
        key: "gst_state",
        dataIndex: "gst_state",
        width: 100,
        dataType: TABLE_DATA_TYPES.STRING,
    },
    erp_name: {
        title: "ERP",
        key: "erp_name",
        dataIndex: "erp_name",
        width: 100,
        dataType: TABLE_DATA_TYPES.STRING,
    },
    is_synced: {
        title: "Sync",
        key: "is_synced",
        dataIndex: "is_synced",
        width: 100,
        render: _ => _ ? "Yes" : "No",
        dataType: TABLE_DATA_TYPES.BOOLEAN,
    },
    aggrement_attached: {
        title: "Agreement Attached",
        key: "aggrement_attached",
        dataIndex: "aggrement_attached",
        width: 180,
        render: _ => _ ? "Yes" : "No",
        dataType: TABLE_DATA_TYPES.BOOLEAN,
    },
    recommendation_letter_attached: {
        title: "Recommendation Letter attached",
        key: "recommendation_letter_attached",
        dataIndex: "recommendation_letter_attached",
        width: 180,
        render: _ => _ ? "Yes" : "No",
        dataType: TABLE_DATA_TYPES.BOOLEAN,
    },
    credit_note_attached: {
        title: "Credit Note attached",
        key: "credit_note_attached",
        dataIndex: "credit_note_attached",
        width: 180,
        render: _ => _ ? "Yes" : "No",
        dataType: TABLE_DATA_TYPES.BOOLEAN,
    },
    disbursal_account_detail_updated: {
        title: "Disbursal account details updated",
        key: "disbursal_account_detail_updated",
        dataIndex: "disbursal_account_detail_updated",
        width: 180,
        render: _ => _ ? "Yes" : "No",
        dataType: TABLE_DATA_TYPES.BOOLEAN,
    },
    company_turnover: {
        title: "Turnover",
        key: "company_turnover",
        dataIndex: "company_turnover",
        width: 100,
        render: _ => formatCurrency(_, true),
        dataType: TABLE_DATA_TYPES.NUMBER,
    },
    total_retailers: {
        title: "Total retailers",
        key: "total_retailers",
        dataIndex: "total_retailers",
        width: 120,
        render: _ => _ || "--",
        dataType: TABLE_DATA_TYPES.NUMBER,
    },
    retailers_qualified: {
        title: "Retailers qualified",
        key: "retailers_qualified",
        dataIndex: "retailers_qualified",
        width: 140,
        render: _ => _ || "--",
        dataType: TABLE_DATA_TYPES.NUMBER,
    },
    sales_coverage: {
        title: "Sales coverage",
        key: "sales_coverage",
        dataIndex: "sales_coverage",
        width: 120,
        render: _ => formatCurrency(_, true),
        dataType: TABLE_DATA_TYPES.NUMBER,
    }
});

export const COMPANY_LOS_PROFILE_COLS = new OrderedMap({
    name: {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width: 300,
        dataType: TABLE_DATA_TYPES.STRING,
        render: (_, record) => generateLink(`/app/companies/${record.id}`, record.name)
        // sorter: (a, b) => stringComparator(a.name, b.name),
    },
    type: {
        title: "Type",
        dataIndex: "type",
        key: "type",
        width: 100,
        dataType: TABLE_DATA_TYPES.ENUM,
        enums: COMPANY_TYPES,
        render: _ => _ ? COMPANY_TYPES.findKey((value) => value === _) : null
    },
    gstin: {
        title: "GST",
        dataIndex: "gstin",
        key: "gstin",
        dataType: TABLE_DATA_TYPES.STRING,
        width: 180
    },
    // cases_as: {
    //     title: "Cases As",
    //     children: new OrderedMap({
    //         no_of_cases_as_seller: {
    //             title: "Seller",
    //             dataIndex: "no_of_cases_as_seller",
    //             key: "no_of_cases_as_seller",
    //             width: 100
    //         },
    //         no_of_cases_as_anchor: {
    //             title: "Anchor",
    //             dataIndex: "no_of_cases_as_anchor",
    //             key: "no_of_cases_as_anchor",
    //             width: 100
    //         },
    //     })
    //         .toList()
    //         .toArray(),
    //     width: 200
    // },
    // is_borrower: {
    //     title: "Is Borrower",
    //     dataIndex: "is_borrower",
    //     key: "is_borrower",
    //     dataType: TABLE_DATA_TYPES.BOOLEAN,
    //     width: 100
    // },
    registered_state_name: {
        title: "Reg. State",
        dataIndex: "registered_state_name",
        key: "registered_state_name",
        dataType: TABLE_DATA_TYPES.STRING,
        width: 150
    },
    anchor: {
        title: "Anchor",
        dataIndex: "anchor",
        key: "anchor",
        dataType: TABLE_DATA_TYPES.STRING,
        width: 150
    },
    brands: {
        title: "Brands",
        dataIndex: "brands",
        key: "brands",
        dataType: TABLE_DATA_TYPES.STRING,
        width: 150
    },
    constitution: {
        title: "Constitution",
        dataIndex: "constitution",
        key: "constitution",
        dataType: TABLE_DATA_TYPES.STRING,
        width: 150
    },
    primary_relationship_manager: {
        title: "Relationship Manager",
        dataIndex: "primary_relationship_manager",
        key: "primary_relationship_manager",
        dataType: TABLE_DATA_TYPES.STRING,
        width: 150
    },
    vp_sales: {
        title: "Vp Sales",
        dataIndex: "vp_sales",
        key: "vp_sales",
        dataType: TABLE_DATA_TYPES.STRING,
        width: 150
    },
    disbursal_details_updated: {
        title: "Disbursal Details Updated",
        dataIndex: "disbursal_details_updated",
        key: "disbursal_details_updated",
        dataType: TABLE_DATA_TYPES.STRING,
        width: 150,
        render: (_) => _ ? "Yes" : "No"
    },
    is_anchor_aligned: {
        title: "Is Anchor Aligned",
        dataIndex: "is_anchor_aligned",
        key: "is_anchor_aligned",
        dataType: TABLE_DATA_TYPES.STRING,
        width: 150,
        render: (_) => _ ? "Yes" : _ == false  ? "No" : "-"
    },
    // throughput: {
    //     title: "Throughput",
    //     dataIndex: "throughput",
    //     key: "throughput",
    //     dataType: TABLE_DATA_TYPES.NUMBER,
    //     width: 200
    // },
    // approved_limit: {
    //     title: "Limit",
    //     dataIndex: "approved_limit",
    //     key: "approved_limit",
    //     dataType: TABLE_DATA_TYPES.NUMBER,
    //     width: 200
    // },
});


export const ERP_SYSTEM = new OrderedMap({
    erp_data_source: {
        label: "ERP Source"
    },
    erp_version: {
        label: "ERP Version"
    }
});

export const BANK_DETAILS = new OrderedMap({
    bank: {
        label: "Bank"
    },
    facility_name: {
        label: "Facility name"
    },
    sanction_limit: {
        label: "Sanction limit"
    },
    sanction_year: {
        label: "Sanction year"
    },
    security_or_collateral: {
        label: "Security or Collateral"
    }
});

export const ANNUAL_TURNOVER = new OrderedMap({
    anchor: {
        label: "Anchor"
    },
    financial_year: {
        label: "Financial Year"
    },
    end_date: {
        label: "End Date"
    },
    amount: {
        label: "Amount"
    }
});

export const COMPANY_BRAND = new OrderedMap({
    channel_product: {
        label: "Channel Product"
    },
    name: {
        label: "Name"
    },
    value_type: {
        label: "Value Type"
    },
    amount: {
        label: "Amount"
    },
    percentage: {
        label: "Percentage"
    },
    subvention_perc: {
        label: "Subvention Percentage"
    },
    subvention_days: {
        label: "Subvention Days"
    },
    is_primary: {
        label: "Is Primary"
    }
});